import { Upload, message } from "antd";

export function createImageMaxSizeValidator(maxWidth: number, maxHeight: number) {
  return (file: File): Promise<boolean | string> => {
    return new Promise((resolve) => {
      const objectUrl = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => {
        URL.revokeObjectURL(objectUrl);
        if (img.naturalWidth > maxWidth || img.naturalHeight > maxHeight) {
          message.error(`ขนาดรูปต้องไม่เกิน ${maxWidth}x${maxHeight} พิกเซล`);
          resolve(Upload.LIST_IGNORE);
        } else {
          resolve(true);
        }
      };
      img.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        message.error("ไม่สามารถอ่านไฟล์รูปภาพได้");
        resolve(Upload.LIST_IGNORE);
      };
      img.src = objectUrl;
    });
  };
}
